/**
 * 为什么不放在conf文件夹内？
 * 因为 conf 文件夹是 nodejs 和 browser 都共用，在conf 通过环境变量判断 prod， dev
 * 如果要判断 boe，需要在scm在注入一个环境变量，把BOE的SCM和 正式的环境分开, 目前SCM是用同一个
 */
// 是否为BOE环境，主要在 登录注册SDK初始化区分环境用
const boeHosts = ['boe-ads.tiktok.com', 'boei18n-ads.byteoversea.net'];
export const isBOE = boeHosts.includes(window.location.host);
